import * as types from "./types";

const mutations = {
  [types.LOADING_MARKETING](state, value) {
    state.loading = value;
  },
  [types.GET_MARKETING](state, appid) {
    state.appid = appid;
  },
  [types.POST_MARKETING_ID](state, appid) {
    state.appid.unshift(appid);
  },
  [types.PUT_MARKETING_ID](state, appid) {
    state.appid.unshift(appid);
  },
  [types.DELETE_MARKETING_ID](state, appid) {
    state.appid.unshift(appid);
  },
  [types.POST_MARKETING_CAMPAIGN](state, campaign) {
    state.campaigns.unshift(campaign);
  },
  [types.UPDATE_CAMPAIGN_STATUS](state, { id, status }) {
    console.log("idddddddddddddddddddddddd", id);
    console.log("idddddddddddddddddddddddd", status);
    const campaign = state.campaigns.find((x) => x.id === id);
    if (campaign) {
      campaign.status = status;
    }
  },

  [types.GET_POSTS](state, posts) {
    state.posts = posts;
  },
  [types.SOCIAL_POST](state, posts) {
    state.posts = posts;
  },
  [types.REMOVE_POST](state, id) {
    state.posts = state.posts.filter((x) => x.id !== id);
  },
  [types.GET_DRAFTS](state, drafts) {
    state.drafts = drafts;
  },
  [types.POST_CAMPAIGN_DRAFT](state, payload) {
    state.drafts.push(payload);
  },
  [types.GET_CAMPAIGNS_LIST](state, campaigns) {
    state.campaigns = campaigns;
  },
  [types.GET_CAMPAIGNS_BYID](state, campaignId) {
    state.campaignId = campaignId;
  },
  [types.GET_CAMPAIGN_DRAFT_LIST](state, drafts) {
    state.drafts = drafts;
  },
  [types.GET_CAMPAIGN_DRAFT_BYID](state, draftId) {
    state.draftId = draftId;
  },
  [types.GET_CAMPAIGN_CONTENTS_BYID](state, draftId) {
    state.draftId = draftId;
  },
  [types.DELETE_CAMPAIGN_DRAFT](state, campaignContentsId) {
    state.drafts = state.drafts.filter(draft => draft.campaignContentsId !== campaignContentsId);
  },
  [types.GET_EVENT_TASK_LIST](state, eventtasks) {
    state.eventtasks = eventtasks;
  },
  [types.GET_COST_LIST](state, cost) {
    state.cost = cost;
  },
  [types.GET_COST_BYID](state, costId) {
    state.costId = costId;
  },
  [types.POST_COST](state, cost) {
    state.cost = cost;
  },
  [types.PUT_COST](state, cost) {
    state.cost = cost;
  },
  [types.DELETE_COST](state, id) {
    if (!Array.isArray(state.cost)) {
      console.error("Error: state.cost is not an array!", state.cost);
      return;
    }

    state.cost = state.cost.filter((x) => x.costId !== id); 
  },
  [types.GET_TASK_LIST](state, task) {
    state.task = task;
  },
  [types.GET_TASK_BYID](state, taskId) {
    state.taskId = taskId;
  },
  [types.POST_TASK](state, task) {
    state.task = task;
  },
  [types.PUT_TASK](state, task) {
    state.task = task;
  },
  [types.DELETE_TASK](state, id) {
    state.task = state.task.filter((x) => x.id !== id);
  },
  [types.GET_ASSIGNEE_LIST](state,assignee){
    state.assignee = assignee;
  },
  [types.POST_KPI](state, kpi) {
    state.Kpis = kpi;
  },
  [types.PUT_TASK](state, kpi) {
    state.Kpis = kpi;
  },
  [types.GET_MARKETING_PLAN](state, marketingPlan){
    state.marketingPlan = marketingPlan;
  },
  [types.GET_MARKETING_TEMPLATE](state, marketingTemplate){
    state.marketingTemplate = marketingTemplate;
  },
};

export default mutations;
